import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/state/auth/AuthContext.jsx';
import { getPermissionCodeForPath, getPermissionCodesForPath } from '@/security/access.js';
import { getFeatureCodeForPath, isTenantFeatureEnabled } from '@/config/tenantFeatures.js';

export default function RouteAccessGuard({ path, children }) {
  const location = useLocation();
  const { can, canAny, tenant } = useAuth();
  const featureCode = getFeatureCodeForPath(path || location.pathname);
  const permissionCode = getPermissionCodeForPath(path || location.pathname);
  const permissionCodes = getPermissionCodesForPath(path || location.pathname) || [];

  if (featureCode && !isTenantFeatureEnabled(tenant, { featureCode })) return <main className="mx-auto max-w-xl p-10 text-center"><h1 className="text-xl font-semibold">Funcionalidad no habilitada</h1><p className="mt-2 text-sm text-slate-500">Esta funcionalidad no se encuentra habilitada para esta empresa.</p></main>;

  if (!permissionCode || can(permissionCode) || canAny(permissionCodes)) {
    return children;
  }

  return <Navigate to="/cargas" replace state={{ from: location, deniedPermission: permissionCode }} />;
}
